import { HttpError } from './HttpError';

export class UnauthorizedError extends HttpError {
	constructor(options?: { cause?: unknown }) {
		super('Unauthorized access', 401, 401, options);
	}
}
